import React from 'react';
import {
    View,
    StyleSheet
} from 'react-native';
import { JDText } from '@jdreact/jdreact-core-lib';
import { pt, px } from '../../common/utils';
import { Link } from '@ltfe/ltfe-core-lib';

const recordTypeMap = {
    0: '绑卡充值',
    1: '订单消费',
    2: '订单回充',
    3: '过期失效',
    4: '影豆过期',
    5: '延期回充',
    6: '影豆作废',
};

export default (props) => {
    const { item = {} } = props;
    const recordType = item?.recordType;
    const newTitle = [0,3,4,5,6].includes(recordType) ? '卡号' : '订单号';
    const newNum = [0,3,4,5,6].includes(recordType) ? item?.certNum : item?.orderId;
    const newAs = recordType === 4 ? '' : ( [0,2,5].includes(recordType) ? '+' : '-');
    const asStyle = ([0,2,5].includes(recordType)) ? {} : styles.as0;
    return <Link style={ styles.record_wrap }>
        <View>
            <JDText type='bold' style={ styles.font_bold }>{`${recordTypeMap[recordType]}（${newTitle}：${newNum}）`}</JDText>
            <JDText style={ styles.font_light }>{item.recordTime}</JDText>
        </View>
        <View>
            <JDText type='regular' style={ [styles.font_color, asStyle] }>{`${newAs}${item?.quantity}`}</JDText>
        </View>
    </Link>;
};

const styles = StyleSheet.create({
    record_wrap: {
        paddingHorizontal: pt(16),
        borderTopColor: 'rgba(0,0,0,0.1)',
        borderTopWidth: px(1),
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingVertical: pt(15),
        backgroundColor: '#FFFFFF'
    },
    font_bold: {
        color: '#252525',
        fontSize: pt(14)
    },
    font_light: {
        color: '#999999',
        fontSize: pt(12),
        marginTop: pt(2)
    },
    font_color: {
        color: '#FC1B00',
        fontSize: pt(15)
    },
    as0: {
        color: '#12B72B',
        fontSize: pt(15)
    }

});
